module.exports = __webpack_public_path__ + "img/zh.cad2c8a4.svg";